import React, { useState, useEffect } from "react";
import { getAuth } from "firebase/auth";
import "./ReportModal.css";

const ReportModal = ({ isOpen, onClose, onSubmit, onDelete, initialData }) => {
  const auth = getAuth();

  const getTodayDateString = () => {
    const now = new Date();
    const jst = new Date(now.getTime() + 9 * 60 * 60 * 1000);
    return jst.toISOString().slice(0, 10);
  };

  const [reportDate, setReportDate] = useState(getTodayDateString());
  const [reporter, setReporter] = useState("");
  const [remarks, setRemarks] = useState("");

  useEffect(() => {
    if (isOpen) {
      setReportDate(initialData?.reportDate || getTodayDateString());
      setRemarks(initialData?.remarks || "");

      const user = auth.currentUser;
      if (user) {
        setReporter(user.displayName || user.email || "匿名ユーザ");
      } else {
        setReporter("未ログイン");
      }
    }
  }, [isOpen, initialData, auth]);

  const handleSubmit = () => {
    onSubmit({ remarks, reportDate, reporter });
    onClose();
  };

  const handleCancel = () => {
    // if (window.confirm("入力内容を破棄しますか？")) {
      onClose();
    // }
  };

  const handleDelete = () => {
    if (window.confirm("本当にこの入力を削除しますか？")) {
      onDelete(); // 親側に削除を通知
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2 className="modal-title">終了報告</h2>

        <label className="modal-label">
          完了日
          <input
            type="date"
            value={reportDate}
            onChange={(e) => setReportDate(e.target.value)}
            className="modal-input"
          />
        </label>

        <label className="modal-label">
          入力者
          <input
            type="text"
            value={reporter}
            readOnly
            className="modal-input read-only"
          />
        </label>

        <label className="modal-label">
          備考
          <textarea
            rows={4}
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            placeholder="備考を入力してください"
            className="modal-textarea"
          />
        </label>

        <div className="modal-buttons">
          {initialData && (
            <button onClick={handleDelete} className="btn delete">
              削除
            </button>
          )}
          <button onClick={handleCancel} className="btn cancel">
            キャンセル
          </button>
          <button onClick={handleSubmit} className="btn submit">
            送信
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportModal;
